/*
 * @Desc: 
 * @Author: lmy
 * @Date: 2025-07-11 10:03:59
 * @LastEditors: lmy
 * @LastEditTime: 2025-10-21 08:41:55
 * @FilePath: \zhongtai-h5\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
Vue.use(Router)
import { getToken, setToken, removeToken } from '@/utils/auth'
const whitePages = ['serveProcess', 'serveHome', 'myserve', 'serveTemp', 'serveSuccess', 'serveLog', 'serveLogDetail']
const routes = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: () => import('@/views/Home.vue'),
            meta: {
                title: '使用服务'
            },
            children: [
                {
                    path: '',
                    name: 'homeYzkindex',
                    component: () => import('@/views/yzkindex.vue'),
                    meta: {
                        title: '悦助康'
                    }
                },
                {
                    path: 'healthVip',
                    name: 'healthVip',
                    meta: {
                        title: '健康会员'
                    },
                    component: () => import('@/views/health/healthVip.vue')
                },
                {
                    path: 'pjHealthVip',
                    name: 'pjHealthVip',
                    meta: {
                        title: '健康会员'
                    },
                    component: () => import('@/views/health/pjHealthVip.vue')
                },
                {
                    path: 'healthVipH5',
                    name: 'healthVipH5',
                    meta: {
                        title: '健康会员'
                    },
                    component: () => import('@/views/healthH5/healthVip.vue')
                },
                {
                    path: 'qyPeo/:serviceType',
                    name: 'qyPeo',
                    meta: {
                        title: '基础信息'
                    },
                    component: () => import('@/views/qyPeo.vue')
                },
                {
                    path: 'qyPeozixun/:serviceType',
                    name: 'qyPeozixun',
                    meta: {
                        title: '咨询单基础信息'
                    },
                    component: () => import('@/views/qyPeozixun.vue')
                },
                {
                    path: '/qyName',
                    name: 'qyName',
                    component: () => import('@/views/qyName.vue'),
                    meta: {
                        title: '需求信息'
                    }
                },
            ]
        },
        {
            path: '/Log',
            name: 'Log',
            component: () => import('@/views/Log.vue'),
            meta: {
                title: '服务记录'
            }
        },
        {
            path: '/LogDetail',
            name: 'LogDetail',
            component: () => import('@/views/LogDetail.vue'),
            meta: {
                title: '服务详情'
            }
        },
        {
            path: '/LogzxDetail',
            name: 'LogzxDetail',
            component: () => import('@/views/LogzxDetail.vue'),
            meta: {
                title: '咨询单服务详情'
            }
        },
        {
            path: '/addPeop',
            name: 'addPeop',
            component: () => import('@/views/addPeop.vue'),
            meta: {
                title: '新增就诊人'
            }
        },
        {
            path: '/Bind',
            name: 'Bind',
            component: () => import('@/views/Bind.vue'),
            meta: {
                title: '服务包信息'
            }
        },
        {
            path: '/descript',
            name: 'descript',
            component: () => import('@/views/descript.vue'),
            meta: {
                title: '服务时效说明'
            }
        },
        {
            path: '/serveDesc',
            name: 'serveDesc',
            component: () => import('@/views/serveDesc.vue'),
            meta: {
                title: '服务细则'
            }
        },
        {
            path: '/witdesc',
            name: 'witdesc',
            component: () => import('@/views/witdesc.vue'),
            meta: {
                title: '等待期说明'
            }
        },

        {
            path: '/fuwu',
            name: 'fuwu',
            component: () => import('@/views/fuwu.vue'),
            meta: {
                title: '服务介绍'
            }
        },
        {
            path: '/jieshao',
            name: 'jieshao',
            component: () => import('@/views/jieshao.vue'),
            meta: {
                title: '服务介绍'
            }
        },
        {
            path: '/dianxin',
            name: 'dianxin',
            component: () => import('@/views/dianxin.vue'),
            meta: {
                title: '重庆电信'
            }
        },
        {
            path: '/yuyue',
            name: 'yuyue',
            component: () => import('@/views/yuyue.vue'),
            meta: {
                title: '服务介绍'
            }
        },
        {
            path: '/yzkindex',
            name: 'yzkindex',
            component: () => import('@/views/yzkindex.vue'),
            meta: {
                title: '悦助康'
            }
        },
        {
            path: '/newsList',
            name: 'newsList',
            component: () => import('@/views/newsList.vue'),
            meta: {
                title: '健康科普'
            }
        },
        {
            path: '/zhuyuan',
            name: 'zhuyuan',
            component: () => import('@/views/zhuyuan.vue'),
            meta: {
                title: '服务介绍'
            }
        },
        {
            path: '/peitong',
            name: 'peitong',
            component: () => import('@/views/peitong.vue'),
            meta: {
                title: '服务介绍'
            }
        },
        {
            path: '/hospital',
            name: 'hospital',
            component: () => import('@/views/hospital.vue'),
            meta: {
                title: '合作医院'
            }
        },
        {
            path: '/physicList',
            name: 'physicList',
            component: () => import('@/views/physicList.vue'),
            meta: {
                title: '除外医师名单'
            }
        },
        {
            path: '/peizhen',
            name: 'peizhen',
            component: () => import('@/views/peizhen.vue'),
            meta: {
                title: '就医陪诊'
            }
        },
        {
            path: '/success',
            name: 'success',
            component: () => import('@/views/success.vue'),
            meta: {
                title: '提交成功'
            }
        },
        {
            path: '/fail',
            name: 'fail',
            component: () => import('@/views/fail.vue'),
            meta: {
                title: '提交失败'
            }
        },
        {
            path: '/peoList',
            name: 'peoList',
            component: () => import('@/views/peoList.vue'),
            meta: {
                title: '就诊人管理'
            }
        },
        {
            path: '/orderLog',
            name: 'orderLog',
            component: () => import('@/views/orderLog.vue'),
            meta: {
                title: '我的权益'
            }
        },
        {
            path: '/orderDetail',
            name: 'orderDetail',
            component: () => import('@/views/orderDetail.vue'),
            meta: {
                title: '权益详情'
            }
        },
        {
            path: '/zhiorderLog',
            name: 'zhiorderLog',
            component: () => import('@/views/zhiorderLog.vue'),
            meta: {
                title: '我的订单'
            }
        },
        {
            path: '/zhiorderDetail',
            name: 'zhiorderDetail',
            component: () => import('@/views/zhiorderDetail.vue'),
            meta: {
                title: '订单详情'
            }
        },
        {
            path: '/productList',
            name: 'productList',
            component: () => import('@/views/productList.vue'),
            meta: {
                title: '产品列表'
            }
        },
        {
            path: '/productDetail',
            name: 'productDetail',
            component: () => import('@/views/productDetail.vue'),
            meta: {
                title: '产品详情'
            }
        },
        {
            path: '/pay/cashier',
            name: 'cashier',
            component: () => import('@/views/cashier.vue'),
            meta: {
                title: '收银台'
            }
        },
        {
            path: '/collCases',
            name: 'collCases',
            component: () => import('@/views/collCases.vue'),
            meta: {
                title: '合作案例'
            }
        },
        {
            path: '/collCasesDetail',
            name: 'collCasesDetail',
            component: () => import('@/views/collCasesDetail.vue'),
            meta: {
                title: '案例详情'
            }
        },
        {
            path: '/serveProcess',
            name: 'serveProcess',
            component: () => import('@/views/serveProcess.vue'),
            meta: {
                title: '服务流程'
            }
        },
        {
            path: '/messList',
            name: 'messList',
            component: () => import('@/views/messList.vue'),
            meta: {
                title: '消息'
            }
        },
        {
            path: '/messDetail',
            name: 'messDetail',
            component: () => import('@/views/messDetail.vue'),
            meta: {
                title: '消息详情'
            }
        },
        {
            path: '/serveHome',
            name: 'serveHome',
            component: () => import('@/views/video/serveHome.vue'),
            meta: {
                title: '权益'
            }
        },
        {
            path: '/myserve',
            name: 'myserve',
            component: () => import('@/views/video/myserve.vue'),
            meta: {
                title: '我的'
            }
        },
        {
            path: '/serveTemp',
            name: 'serveTemp',
            component: () => import('@/views/video/serveTemp.vue'),
            meta: {
                title: '咨询服务'
            }
        },
        {
            path: '/serveSuccess',
            name: 'serveSuccess',
            component: () => import('@/views/video/serveSuccess.vue'),
            meta: {
                title: '提交成功'
            }
        },
        {
            path: '/serveLog',
            name: 'serveLog',
            component: () => import('@/views/video/serveLog.vue'),
            meta: {
                title: '服务记录'
            }
        },
        {
            path: '/serveLogDetail',
            name: 'serveLogDetail',
            component: () => import('@/views/video/serveLogDetail.vue'),
            meta: {
                title: '服务详情'
            }
        },
        {
            path: '/successVip',
            name: 'successVip',
            component: () => import('@/views/health/successVip.vue'),
            meta: {
                title: '订阅成功'
            }
        },
        {
            path: '/successVipH5',
            name: 'successVipH5',
            component: () => import('@/views/healthH5/successVip.vue'),
            meta: {
                title: '订阅成功'
            }
        },
        {
            path: '/pjSuccessVipH5',
            name: 'pjSuccessVipH5',
            component: () => import('@/views/healthH5/pjSuccessVip.vue'),
            meta: {
                title: '订阅成功'
            }
        },
        {
            path: '/cancelVip',
            name: 'cancelVip',
            component: () => import('@/views/health/cancelVip.vue'),
            meta: {
                title: '退订成功'
            }
        },
        // 单页
        {
            path: '/landingPage',
            name: 'landingPage',
            component: () => import('@/views/landingPage.vue'),
            meta: {
                title: ''
            }
        },
         {
            path: '/dingSuccess',
            name: 'dingSuccess',
            component: () => import('@/views/dingSuccess.vue'),
            meta: {
                title: '订购成功'
            }
        },
         {
            path: '/zjydDetail',
            name: 'zjydDetail',
            component: () => import('@/views/zjydDetail.vue'),
            meta: {
                title: '浙江移动好就医'
            }
        },
    ]
})
// ⭐️ 路由守卫：切换页面时更新浏览器标题
routes.beforeEach((to, from, next) => {
    const { orderId, serviceType, token } = to.query
    if (to.meta && to.meta.title) {
        document.title = to.meta.title
    }
    // 除外医师名单页面/合作医院页面无需 token 验证
    if (to.name === 'homeYzkindex' || to.name === 'yzkindex' || to.name === 'physicList' || to.name === 'hospital' || to.name === 'fuwu'||to.name === 'jieshao'||to.name === 'productList'||to.name === 'productDetail'||to.name === 'collCases'||to.name === 'collCasesDetail'||to.name === 'yuyue'||to.name === 'peitong'||to.name === 'zhuyuan'||to.name === 'landingPage'||to.name=='cashier'||to.name=='newsList'||to.name=='zjydDetail'||to.name=='healthVip'||to.name=='pjHealthVip'||to.name=='healthVipH5'||to.name=='successVip'||to.name=='successVipH5'||to.name=='cancelVip'||to.name === 'dianxin'||to.name=='pjSuccessVipH5') {
        if(token){
            let obj = {
            token: token,
        }
            let paramsStra = JSON.stringify(obj)
            setToken(paramsStra)
        }
        next();
        return; // 直接返回，不执行后续验证逻辑
    }
    // ?orderId=xxx&serviceType=xxx&token=xxx
    // 获取 query 参数
    // const { orderId, serviceType, token } = to.query
    // 把 token 存到 store
    if (orderId && serviceType && token) {
        localStorage.removeItem("homeZtForms");
        localStorage.removeItem("nameZtFormData");
        localStorage.removeItem("failZtReson");

        let obj = {
            orderId: orderId,
            token: token,
            serviceType: serviceType
        }
        let paramsStr = JSON.stringify(obj)
        setToken(paramsStr)
        next()

    } else if (orderId && token) {
        let obj = {
            orderId: orderId,
            token: token,
        }
        let paramsStr = JSON.stringify(obj)
        setToken(paramsStr)
        next()

    } else {
        if (token) {
            let obj = {
                token: token,
            }
            let paramsStr = JSON.stringify(obj)
            setToken(paramsStr)
            next()

        } else {
            if (getToken()) {
                next()
            } else {
                // 未登录
                if (whitePages.includes(to.name)) {
                    // 白名单放行
                    console.log(to.name)
                    next()
                }
            }

        }
    }

})
export default routes